import styled, { css } from 'styled-components';
import { Badge } from 'antd';

import Colors from '@/v2/constants/Colors';

export const Container = styled.div`
  ${({ $color }) => css`
    display: flex;
    justify-content: center;
    align-items: center;

    aspect-ratio: 1;
    background-color: ${$color};
    border-radius: 50%;
    padding: 8px;
  `}

  ${({ width, height }) =>
    width && height
      ? css`
          width: ${width}px;
          height: ${height}px;
        `
      : ''}
`;

export const IconBadge = styled(Badge)`
  .ant-badge-count {
    background-color: white;
    color: ${Colors.NEUTRAL_VARIANTS[80]};
    box-shadow: 0 0 0 1px ${Colors.NEUTRAL_VARIANTS[80]};
    min-width: 15px;
    height: 15px;
    line-height: 15px;
    font-size: 11px;
    padding: 0 3px;
  }
`;
